(function () {
  function activateTab(section, tab) {
    var tabs = section.querySelectorAll('[data-braidjoy-product-tabs-tab]');
    var panels = section.querySelectorAll('[data-braidjoy-product-tabs-panel]');
    var panelId = tab.getAttribute('aria-controls');

    tabs.forEach(function (item) {
      var isActive = item === tab;
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach(function (panel) {
      panel.hidden = panel.id !== panelId;
    });
  }

  function initSection(section) {
    if (!section || section.dataset.braidjoyProductTabsInitialized === 'true') {
      return;
    }

    var tabs = section.querySelectorAll('[data-braidjoy-product-tabs-tab]');

    if (!tabs.length) {
      return;
    }

    section.dataset.braidjoyProductTabsInitialized = 'true';

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(section, tab);
      });

      tab.addEventListener('keydown', function (event) {
        var currentTabs = Array.prototype.slice.call(section.querySelectorAll('[data-braidjoy-product-tabs-tab]'));
        var currentIndex = currentTabs.indexOf(tab);
        var nextIndex = currentIndex;

        if (event.key === 'ArrowRight') {
          nextIndex = currentIndex + 1 >= currentTabs.length ? 0 : currentIndex + 1;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = currentIndex - 1 < 0 ? currentTabs.length - 1 : currentIndex - 1;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = currentTabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        currentTabs[nextIndex].focus();
        activateTab(section, currentTabs[nextIndex]);
      });
    });

    activateTab(section, tabs[0]);
  }

  function initAll() {
    document.querySelectorAll('[data-braidjoy-product-tabs]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target.querySelector('[data-braidjoy-product-tabs]'));
  });
})();
